import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import { useParseDocumentToHtml } from '~/composables/useParseDocumentToHtml';
import useProductContent from '~/composables/useProductContent/useProductContent';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
export default defineComponent({
  name: 'Basic',
  components: {
    BaseBreadcrumbs: function BaseBreadcrumbs() {
      return import('~/components/Layout/BaseBreadcrumbs.vue');
    },
    BaseSingleBreadcrumb: function BaseSingleBreadcrumb() {
      return import('~/components/Layout/BaseSingleBreadcrumb.vue');
    },
    AzLoader: AzLoader,
    AzImg: function AzImg() {
      return import('~/components/Atoms/AzImg.vue');
    },
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    content: {
      type: Object,
      default: function _default() {}
    },
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: Boolean
  },
  setup: function setup(props) {
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var contentTitle = computed(function () {
      var _props$content;
      return ((_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.title) || '';
    });
    var components = computed(function () {
      return mapComponentName(props.tabs);
    });
    var breadcrumbs = computed(function () {
      var _props$content2, _props$content3;
      if (!((_props$content2 = props.content) !== null && _props$content2 !== void 0 && _props$content2.breadcrumb)) return null;
      return (_props$content3 = props.content) === null || _props$content3 === void 0 ? void 0 : _props$content3.breadcrumb.map(function (_ref) {
        var f = _ref.fields;
        return {
          text: f.title,
          link: f.url
        };
      }).reverse();
    });
    var description = computed(function () {
      var _props$content4;
      return (_props$content4 = props.content) === null || _props$content4 === void 0 ? void 0 : _props$content4.description;
    });
    var _useParseDocumentToHt = useParseDocumentToHtml(description, []),
      parsedDescription = _useParseDocumentToHt.html;
    var mainImage = computed(function () {
      var _props$content5, _props$content5$mainI, _props$content5$mainI2, _props$content5$mainI3;
      return ((_props$content5 = props.content) === null || _props$content5 === void 0 ? void 0 : (_props$content5$mainI = _props$content5.mainImage) === null || _props$content5$mainI === void 0 ? void 0 : (_props$content5$mainI2 = _props$content5$mainI.fields) === null || _props$content5$mainI2 === void 0 ? void 0 : (_props$content5$mainI3 = _props$content5$mainI2.file) === null || _props$content5$mainI3 === void 0 ? void 0 : _props$content5$mainI3.url) || null;
    });
    onMounted(function () {
      window.scrollTo(0, 0);
      setDynamicYieldContext('OTHER', ['Basic_Page']);
    });
    setDynamicYieldContextSSR('OTHER', ['Basic_Page']);
    return {
      breadcrumbs: breadcrumbs,
      components: components,
      parsedDescription: parsedDescription,
      mainImage: mainImage,
      contentTitle: contentTitle,
      isMobile: isMobile
    };
  }
});